module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ark-div', {
    staticClass: "ark-leaderboard-content"
  }, [(_vm.leaderboardData[_vm.chosenPeriod].length) ? _c('ark-table', {
    staticClass: "ark-leaderboard-table"
  }, _vm._l((_vm.leaderboardData[_vm.chosenPeriod]), function(user) {
    return _c('ark-tr', {
      key: user.userId,
      staticClass: "ark-leaderboard-table__row",
      attrs: {
        "ark-test-id": "leaderboard-user-row"
      }
    }, [_c('ark-td', {
      staticClass: "ark-leaderboard-table__cell ark-leaderboard-table__place"
    }, [_vm._v(_vm._s(user.rank))]), _vm._v(" "), _c('ark-td', {
      staticClass: "ark-leaderboard-table__cell ark-leaderboard-table__avatar"
    }, [(user.avatarUrl) ? _c('img', {
      attrs: {
        "src": user.avatarUrl
      }
    }) : _c('img', {
      attrs: {
        "src": "http://ams.cdn.arkadiumhosted.com/assets/arena-4/arena/heap/no_avatar.jpg"
      }
    })]), _vm._v(" "), _c('ark-td', {
      staticClass: "ark-leaderboard-table__cell ark-leaderboard-table__name"
    }, [_vm._v(_vm._s(_vm._f("name")(user.userName)))]), _vm._v(" "), _c('ark-td', {
      staticClass: "ark-leaderboard-table__cell ark-leaderboard-table__score"
    }, [_vm._v(_vm._s(user.value))])], 1)
  })) : _c('ark-div', {
    staticClass: "ark-leaderboard-info-text"
  }, [_vm._v(_vm._s(_vm.emptyLeaderboardText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3044be2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeaderboardContent/LeaderboardContent.vue
// module id = 14
// module chunks = 0